import styled from "styled-components";

const OnboardingFlowStWrapper = styled.div`
font-family: 'Lato', sans-serif !important;

`;
export { OnboardingFlowStWrapper }